import React from "react";
import { Card, CardMedia, CardContent, Typography } from "@mui/material";

const ShowCaseCard = ({ image, altText, title, description }) => (
  <Card
    sx={{
      borderRadius: 4,
      boxShadow: 'none',
      border: '1px solid rgba(0,0,0,0.06)',
      transition: 'all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      '&:hover': {
        transform: 'translateY(-8px)',
        boxShadow: '0 20px 48px rgba(0,0,0,0.1)',
        borderColor: 'rgba(11,116,193,0.15)',
      },
      overflow: 'hidden',
    }}
  >
    <CardMedia
      component="img"
      height="240"
      image={image}
      alt={altText}
      loading="lazy"
      sx={{
        transition: 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        '&:hover': {
          transform: 'scale(1.06)',
        },
      }}
    />
    <CardContent
      sx={{
        p: 3,
        backgroundColor: '#fff',
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          color: '#1d1d1f',
          letterSpacing: '-0.015em',
          fontSize: { xs: '1.15rem', md: '1.35rem' },
          mb: 0.75,
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontWeight: 400,
          color: 'rgba(29,29,31,0.65)',
          fontSize: { xs: '0.9rem', md: '0.95rem' },
          lineHeight: 1.6,
        }}
      >
        {description}
      </Typography>
    </CardContent>
  </Card>
);

export default ShowCaseCard;
